import React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import PermissionDecoratorV2 from '../../../components/utils/permission/PermissionDecoratorV2';
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * This component replace using GridActionsCellItem / GridActionsCell.
 * We implement our control button + MUI Menu, which replaces showInMenu
 * (creates a menu from actions, rather than simply displaying buttons
 * inside a cell).
 */

interface StationActionsCellProps {
  params: GridRenderCellParams;
}

export function StationActionsCell({ params }: StationActionsCellProps) {
  const { t } = useTranslation('commons');
  const row = params.row;

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <Box className="mui-actions-cell">
      <IconButton size="small" onClick={handleOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={3}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              transform: 'translateX(-100%) !important',
            },
          },
        }}
      >
        <PermissionDecoratorV2 item={'device_sites_actions_button'}>
          <MenuItem
            onClick={() => {
              handleClose();
              row.onDelete?.();
            }}
          >
            <ListItemIcon>
              <DeleteIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t('Supprimer')}</ListItemText>
          </MenuItem>
        </PermissionDecoratorV2>

        {/* When we have more than 1 button, we accept handler for them from the
          parent component (StationList.tsx) and use them in another buttons */}
        {/* <PermissionDecoratorV2 item={'device_sites_actions_button'}>
            <MenuItem
              onClick={() => {
                handleClose();
                row.onLog?.()
              }}>
                <ListItemIcon>
                  <SecurityIcon fontSize='small'/>
                </ListItemIcon>
                <ListItemText>Log</ListItemText>
            </MenuItem>
          </PermissionDecoratorV2> */}
      </Menu>
    </Box>
  );
}
